// age.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { Timestamp } from 'firebase/firestore';

@Pipe({ name: 'age', standalone: true, pure: true })
export class AgePipe implements PipeTransform {
  private toDate(value: any): Date | null {
    if (!value) return null;
    if (value instanceof Date) return value;
    if (typeof value?.toDate === 'function') return value.toDate(); // Firestore Timestamp
    if (typeof value === 'string' || typeof value === 'number') {
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d;
    }
    return null;
  }

  transform(fechaNacimiento?: Date | Timestamp | string | number): string {
    const nacimiento = this.toDate(fechaNacimiento);
    if (!nacimiento) return '';

    const hoy = new Date();

    // Años completos
    let anios = hoy.getFullYear() - nacimiento.getFullYear();
    const m = hoy.getMonth() - nacimiento.getMonth();
    const d = hoy.getDate() - nacimiento.getDate();
    if (m < 0 || (m === 0 && d < 0)) anios--;

    if (anios >= 1) return `${anios} año${anios > 1 ? 's' : ''}`;

    // Meses completos (<1 año)
    let meses = (hoy.getFullYear() - nacimiento.getFullYear()) * 12 + (hoy.getMonth() - nacimiento.getMonth());
    if (hoy.getDate() < nacimiento.getDate()) meses--;
    meses = Math.max(0, meses);

    return `${meses} mes${meses !== 1 ? 'es' : ''}`;
  }
}
